import http from './httpService';

export function getAllCostEstimations() {
  return http.get(`/cost-estimations`);
}

export function createCostEstimation(payload) {
  return http.post(`/cost-estimations`, payload);
}

export function updateCostEstimation(payload) {
  return http.put(`/cost-estimations`, payload);
}

export function deleteCostEstimation(id) {
  return http.delete(`/cost-estimations/${id}`);
}
